const DEFAULT_AUTOPAY_GROUP_TYPES = new Set(["Association", "Individual"]);

export const resolveInitialAutoPay = ({groupType, autoPay, paymentMethods, hasPendingMicroDeposits}) => {
    if (autoPay === true) {
        return true;
    }

    const hasSavedPaymentMethod = Array.isArray(paymentMethods) && paymentMethods.length > 0;
    if (autoPay === false && (hasSavedPaymentMethod || hasPendingMicroDeposits)) {
        return false;
    }

    return DEFAULT_AUTOPAY_GROUP_TYPES.has(groupType) && !hasSavedPaymentMethod && !hasPendingMicroDeposits;
};

export const shouldEnableAutopayByDefault = ({groupType, autoPay, paymentMethods, microDepositsBankAccounts}) => {
    if (autoPay === true) {
        return false;
    }

    return resolveInitialAutoPay({
        groupType,
        autoPay,
        paymentMethods,
        hasPendingMicroDeposits: Array.isArray(microDepositsBankAccounts) && microDepositsBankAccounts.length > 0,
    });
};
